import { Archive, BookOpen, Activity, Blocks, Boxes, Briefcase, Calculator, Calendar, CalendarCheck, ClipboardCheck, ClipboardList, KeyRound, LayoutDashboard, ListChecks, Settings, ShieldCheck, UserCircle, Users, WalletCards, ChartNoAxesCombined, ContactRound, Palmtree, Receipt, FileSpreadsheet, PackageSearch, ShoppingCart, TrendingUp, BarChart3, Building2, FolderTree, ArrowUpRight, MessageSquare, Megaphone, Zap, Bot, Smartphone, Send, Flame } from 'lucide-react'
import { Outlet } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import AppShell from './AppShell'

export default function LayoutAdmin({ children }) {
  const { user, features, hasModule } = useAuth()
  const settings = [
    { to: '/configuracoes', icon: Settings, label: 'Geral' },
    { to: '/usuarios', icon: Users, label: 'Usuários' },
    { to: '/auditoria', icon: ShieldCheck, label: 'Auditoria' },
    { to: '/saude', icon: Activity, label: 'Saúde operacional' },
    { to: '/configuracoes?tab=integracoes', icon: Blocks, label: 'Integrações' },
  ].filter(item => item.to === '/configuracoes?tab=integracoes'
    ? hasModule('configuracoes')
    : hasModule(({ '/configuracoes':'configuracoes', '/usuarios':'usuarios', '/auditoria':'auditoria', '/saude':'saude' })[item.to]))
  
  const navItems = [
    { to: '/hoje', icon: CalendarCheck, label: 'Hoje', section: 'Operação' },
    { to: '/', icon: LayoutDashboard, label: 'Dashboard', section: 'Operação' },
    ...(hasModule('crm') && features.crm?.enabled ? [{
      to: '/crm',
      icon: Briefcase,
      label: 'CRM & Vendas',
      section: 'Vendas & Relacionamento',
      children: [
        { to: '/crm', icon: Briefcase, label: 'Funil de Vendas' },
        ...((user?.role === 'admin' || user?.role === 'financeiro') ? [{ to: '/crm/produtividade', icon: Flame, label: 'Produtividade' }] : []),
        { to: '/crm/analytics', icon: ChartNoAxesCombined, label: 'Analytics Comercial' },
        ...((user?.role === 'admin' || user?.role === 'financeiro') ? [{ to: '/crm/configuracoes', icon: Settings, label: 'Configurações do CRM' }] : []),
      ]
    }] : []),
    {
      to: '/atendimento',
      icon: MessageSquare,
      label: 'Atendimento',
      section: 'Operação & Suporte',
      children: [
        { to: '/atendimento', icon: MessageSquare, label: 'Chat (Chatwoot)' },
        { to: '/atendimento/conexao', icon: Smartphone, label: 'Conexão & Status' },
        { to: '/atendimento/regua', icon: Zap, label: 'Régua de Disparos' },
        { to: '/atendimento/agendamentos', icon: Calendar, label: 'Agendamentos' },
        { to: '/atendimento/campanhas', icon: Send, label: 'Campanhas & Disparos' },
        { to: '/atendimento/auto-replies', icon: Bot, label: 'Respostas Rápidas' },
        { to: '/atendimento/seguranca', icon: ShieldCheck, label: 'Controle de Acesso' },
        { to: '/atendimento/configuracoes', icon: Settings, label: 'Configurações & IA' },
      ]
    },
    { to: '/clientes', icon: UserCircle, label: 'Clientes', section: 'Operação & Suporte' },
    { to: '/chamados', icon: ClipboardList, label: 'Chamados', section: 'Operação & Suporte' },
    { to: '/senhas', icon: KeyRound, label: 'Banco de senhas', section: 'Operação & Suporte' },
    { to: '/agenda', icon: Calendar, label: 'Agenda', section: 'Gestão' },
    { to: '/rotinas', icon: ClipboardCheck, label: 'Rotinas', section: 'Gestão' },
    { to: '/ativos', icon: Archive, label: 'Ativos', section: 'Gestão' },
    { to: '/diretoria-ia', icon: Bot, label: 'Diretoria IA', section: 'Inteligência Artificial' },
    { to: '/conhecimento', icon: BookOpen, label: 'Base de conhecimento', section: 'Conhecimento' },
    ...(hasModule('produtos_estoque') ? [{ to: '/produtos', icon: Boxes, label: 'Catálogo & Estoque', section: 'Produtos & Estoque', children: [
      { to: '/produtos', icon: PackageSearch, label: 'Catálogo de produtos' },
      { to: '/produtos/planos', icon: PackageSearch, label: 'Planos de produtos' },
      { to: '/produtos/modulos', icon: Blocks, label: 'Módulos e funcionalidades' },
      { to: '/produtos/estoque', icon: Boxes, label: 'Estoque e movimentações' },
      { to: '/produtos/compras', icon: ShoppingCart, label: 'Compras e recebimentos' },
      { to: '/produtos/reservas', icon: ClipboardCheck, label: 'Reservas e entregas' },
      { to: '/produtos/inventarios', icon: ListChecks, label: 'Inventários e conciliação' },
    ],
  }] : []),
    { to: '/financeiro', icon: WalletCards, label: 'Financeiro', section: 'Financeiro', children: [
      { to: '/financeiro', icon: LayoutDashboard, label: 'Visão financeira' },
      { to: '/financeiro/pagar', icon: ArrowUpRight, label: 'Contas a Pagar' },
      { to: '/financeiro/faturas', icon: Receipt, label: 'Cobranças & Recebíveis' },
      { to: '/financeiro/contas', icon: Building2, label: 'Tesouraria & Bancos' },
      { to: '/financeiro/conciliacao', icon: FileSpreadsheet, label: 'Conciliação OFX' },
      { to: '/financeiro/fluxo', icon: TrendingUp, label: 'Fluxo de Caixa' },
      { to: '/financeiro/dre', icon: BarChart3, label: 'DRE Gerencial' },
      { to: '/financeiro/plano-contas', icon: FolderTree, label: 'Plano de Contas' },
      { to: '/financeiro/operacao', icon: WalletCards, label: 'Rentabilidade' },
      { to: '/financeiro/capacidade', icon: Activity, label: 'Capacidade operacional' },
      { to: '/financeiro/precificacao', icon: Calculator, label: 'Precificação' },
    ] },
    ...((user?.role !== 'tecnico' || user?.bate_ponto) ? [{ to: user?.role === 'tecnico' ? '/pessoas/ponto' : '/pessoas/equipe', icon: ContactRound, label: 'RH & Pessoas', section: 'Administração', children: [
      ...(user?.role === 'tecnico' ? [
        { to: '/pessoas/ponto', icon: CalendarCheck, label: 'Bater ponto' },
        { to: '/pessoas/folha', icon: ClipboardList, label: 'Folha de ponto' },
        { to: '/pessoas/ferias', icon: Palmtree, label: 'Minhas férias' },
        { to: '/pessoas/folha-pagamento', icon: Receipt, label: 'Meus holerites' },
      ] : []),
      ...(user?.role !== 'tecnico' ? [
        { to: '/pessoas/equipe', icon: Users, label: 'Colaboradores' },
        { to: '/pessoas/ferias', icon: Palmtree, label: 'Gestão de Férias' },
        { to: '/pessoas/folha-pagamento', icon: Receipt, label: 'Folha de Pagamento' },
        { to: '/pessoas/rescisoes', icon: FileSpreadsheet, label: 'Rescisões & TRCT' },
        ...(user?.role === 'admin' ? [{ to: '/pessoas/gestao-ponto', icon: CalendarCheck, label: 'Gestão de ponto' }] : []),
        { to: '/pessoas/acertos', icon: ClipboardCheck, label: 'Acertos & KM' },
        { to: '/pessoas/configuracao', icon: Settings, label: 'Configuração de RH' },
      ] : []),
    ] }] : []),
    ...(settings.length ? [{
      to: hasModule('configuracoes') ? '/configuracoes' : settings[0].to,
      icon: Settings,
      label: 'Configurações',
      section: 'Administração',
      children: settings,
    }] : []),
  ].filter(item => item.to.startsWith('/pessoas') ? hasModule('pessoas') : hasModule(({ '/hoje':'hoje', '/':'dashboard', '/clientes':'clientes', '/chamados':'chamados', '/atendimento':'chamados', '/senhas':'senhas', '/capacidade':'financeiro', '/rotinas':'rotinas', '/ativos':'gestao', '/conhecimento':'gestao', '/diretoria-ia':'gestao', '/crm':'crm', '/produtos':'produtos_estoque', '/financeiro':'financeiro', '/agenda':'agenda', '/configuracoes':'configuracoes', '/usuarios':'usuarios', '/auditoria':'auditoria', '/saude':'saude' })[item.to]))
  
  const labels = { admin: 'Administrador', tecnico: 'Técnico', financeiro: 'Financeiro' }
  return <AppShell navItems={navItems} roleLabel={labels[user?.role] || 'Usuário interno'} showNotifications>{children || <Outlet />}</AppShell>
}
